import { render } from "./OrganizationsTable.vue?vue&type=template&id=3bf4054c&scoped=true"
import script from "./OrganizationsTable.vue?vue&type=script&lang=js"
export * from "./OrganizationsTable.vue?vue&type=script&lang=js"

import "./OrganizationsTable.vue?vue&type=style&index=0&id=3bf4054c&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf4054c"]])

export default __exports__